import api from '@/lib/api';

export interface AgentCaseListItem {
  id: string;
  ticket_id: string;
  status: string;
  goal?: string;
  summary?: string;
  internal_comm_count: number;
  updated_at: string;
  ticket_number: string;
  subject: string;
}

export interface AgentCaseEvent {
  kind: string;
  content?: string;
  metadata?: Record<string, unknown> | null;
  created_at: string;
}

export interface AgentCaseTrigger {
  trigger_type: string;
  status: string;
  fire_at?: string | null;
  fired_at?: string | null;
  watch_ticket_id?: string | null;
  watch_ticket_number?: string | null;
  metadata?: Record<string, unknown> | null;
  created_at: string;
}

export interface AgentCaseDetail {
  case: AgentCaseListItem & { goal?: string; summary?: string; resume_count?: number; created_at: string };
  events: AgentCaseEvent[];
  triggers: AgentCaseTrigger[];
}

class AgentCasesService {
  async list(): Promise<AgentCaseListItem[]> {
    const res = await api.get('/agent-cases');
    return res.data?.data || [];
  }

  async getByTicket(ticketId: string): Promise<AgentCaseDetail | null> {
    try {
      const res = await api.get(`/agent-cases/${ticketId}`);
      return res.data?.data || null;
    } catch (e: any) {
      if (e?.response?.status === 404) return null; // agent case yok → boş
      throw e;
    }
  }
}

export default new AgentCasesService();
